import { NgModule } from 'ng-metadata/core';
import { CheckoutModule } from './checkout/checkout.module';
import { VisaProcessingModule } from './visa-processing/visa-processing.module';
import { PassportProcessingModule } from './passport-processing/passport-processing.module';
import { ProductRequirementsModule } from './product-requirements/product-requirements.module';
import { CommentModule } from './comment/comment.module';
import { TrackOrderModule } from './track-order/track-order.module';

@NgModule({
  imports: [
    CheckoutModule,
    VisaProcessingModule,
    PassportProcessingModule,
    ProductRequirementsModule,
    CommentModule,
    TrackOrderModule,
  ],
  declarations: [],
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./resources/assets/js/components/components.module.ts